export const setMessage = (message) => ({
    type: "TROLLEY/SETTROLLEYMESSAGE",
    message,
})
